module.exports = __webpack_public_path__ + "media/ES_Multimedia_781.95f0d9e6.mp3";